/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */

import type { InsuranceType } from '../types';

export const HOME_INSURANCE_TYPE: InsuranceType = 'home';
export const ABOUT_YOU = 'aboutYou';
export const YOUR_COVER = 'yourCover';
export const CAR_INSURANCE_TYPE: InsuranceType = 'car';
export const TRAVEL_INSURANCE_TYPE: InsuranceType = 'travel';
export const MARKETING_CONSENT = 'marketing';
export const SAVINGS_AND_INVEST_INSURANCE_TYPE = 'savingsAndInvestments';
export const OPTIONAL_EXTRAS = ['CONAD', 'PNCD', 'HEAOPT', 'AFTEROPTEX'];
export const AFTER_SALES_DISCOUNT = ['BOICUS', 'BOIMUL', 'BOICAR', 'PROMOPCT'];
export const CODE_VALUES = {
  RSA: '26',
  FBD: 'INCLEVY'
};
export const ENABLED = 'enabled';
export const RENEWAL = 'renewal';
export const RESUME = 'resume';

export const allInsuranceTypes: InsuranceType[] = ['home', 'car', 'travel'];

export const premiumBreakDownConstants = {
  BOICAR: 'BOICAR',
  BOICUS: 'BOICUS',
  BOIMUL: 'BOIMUL',
  PROMOPCT: 'PROMOPCT',
  CONAD: 'CONAD',
  PNCD: 'PNCD',
  HEAOPT: 'HEAOPT',
  AFTEROPTEX: 'AFTEROPTEX',
  INCLEVY: 'INCLEVY',
  LEVY: 'LEVY',
  AFTERLOADDISC: 'AFTERLOADDISC',
  AFTERSALES: 'AFTERSALES'
};

export const featureFlags = {
  home_enabled: true,
  home_renewal_enabled: true,
  home_resume_enabled: true,
  motor_enabled: true,
  travel_enabled: true,
  home_premium_discounts_enabled: true,
  bind_upload_enabled: true,
  mortgage_provider_update_enabled: true,
  marketing_enabled: true
};
